<div class="text-left py-2 lg:py-2 lg:px-0 xl:py-2 xl:px-0">
  <p class="text-left  font-light md:text-lg mt-4 mb-6">{{description}}</p>
</div>